import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ChildTile from "../Common/ChildTile";
import ContentTile from "./ContentTile";
import Header from "../Common/Header";
import LoadMore from "./LoadMore";
import { triggerSponsorshipAnalyticsEvent } from "../../utils/analytics-helpers.js";
import { childImage, donateEnvironment } from "../../utils/helpers.js";
import Messaging from "../Common/Messaging";
import {
  getChildren,
  searchMethodUpdater,
  statusUpdater
} from "wvus-sponsorship-engine";
import helpers, { getParams } from "wvus-sponsorship-engine";
import { getSearchDefaultParams, mergeSearchDefaultParams, getErrorMessage } from '../../utils/app-settings';

class GridView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderGrid: false,
      descriptorList: [],
    };
  }

  componentDidMount() {
    this.props.animateGrid(true);
    this.props.setGridWasActive(true);
    const obj = this.props.lastSearchKeyObj;
    if (Object.keys(this.props.lastSearchKeyObj).length > 0 && this.props.lastSearchKeyObj.constructor === Object) {
      let foundSearch = false;
      const searchTerms = JSON.stringify(this.props.lastSearchKeyObj);
      this.setState({
        renderGrid: true,
      });
      this.props.statusUpdater("COMPLETE");
      //no kids in redux
    } else {
      const urlParams = helpers.getParams();
      const searchDefaultParams = getSearchDefaultParams();
      const searchParams = Object.keys(searchDefaultParams).length ? mergeSearchDefaultParams(urlParams) : urlParams;

      if (typeof this.props.projectIdentifiers != undefined && this.props.projectIdentifiers.length > 0) {
        searchParams.projectIdentifiers = this.props.projectIdentifiers;
      }
      if (typeof this.props.reservePool != undefined && this.props.reservePool != null) {
        searchParams.reservationReferenceIdentifier = this.props.reservePool;
      }
      //if child is unavailable(locked) we search the grid with params
      if (
        this.props.child_unavailable.child_unavailable_search &&
        this.props.child_unavailable.child_unavailable_searchTerms.length > 0
      ) {
        const child_unavailable_terms = this.props.child_unavailable.child_unavailable_searchTerms;
        searchParams[child_unavailable_terms[0]] = child_unavailable_terms[1];
      }
      this.props.getChildren(this.props.take, searchParams, () => {
        if (this.props.searchMethod === "search") {
          let adpName = null;
          const searchRequest = this.props.searchRequest.children.response[0];

          if (this.props.searchRequest.children.request.searchCriteriaList[0].hasOwnProperty("projectIdentifiers")) {
            if (
              this.props.searchRequest.children.request.searchCriteriaList[0].projectIdentifiers.length > 0 &&
              Object.keys(this.props.children).length > 0
            ) {
              adpName = this.props.children[searchRequest].projectName;
            } else {
              adpName = this.props.searchRequest.children.request.searchCriteriaList[0].projectIdentifiers[0];
            }

            if (window.wv_rcds.settings.projectDescription != "" && this.props.children) {
              adpName = window.wv_rcds.settings.projectDescription;
            }

            //check if adp is searched
            this.props.searchRequest.children.request.searchCriteriaList[0].projectIdentifiers.length > 0
              ? this.props.setADPStatus(true, adpName)
              : "";
          }
        }
      });

      this.setState({
        renderGrid: true,
      });
    }
  }

  classList(classList = "", property, test) {
    if (property === test) {
      return classList;
    }
    return [];
  }

  renderNoResults() {
    if (this.props.status == "COMPLETE" && this.props.submissions.children.responseData.totalCount === 0) {
      return <p>No children were found, please try again</p>;
    }
  }

  renderHeader(props) {
    if (props.device === "tablet" || props.device === "mobile") {
      return (
        <Header
          parentCssClass="content-tile rowspan-100 orange-gradient"
          childCssClass=""
          title="Why should I sponsor a child?"
          text="Sponsoring a child is a personal way to show God's love to a child in need. For $39 a month, you'll help that child and their community to stand tall, free from poverty."
          mobileImg="https://wvusstatic.com/2018/sponsorship-app/heart.svg"
        />
      );
    } else {
      return false;
    }
  }

  renderContentTiles(props, itemNo, tileNumber, gridVars) {
    const contentItems = props.content;
    return (
      <ContentTile
        key={itemNo}
        contentProps={contentItems[tileNumber]}
        gridVars={gridVars}
        device={this.props.device}
        status={this.props.status}
        gridVarsReceived={this.props.gridVarsReceived}
      />
    );
  }

  tileChooser(props, index, item, gridVars, itemCount) {
    switch (index) {
      case 2:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 1, gridVars)}
            <ChildTile
              key={index*200}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 6:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 0, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 13:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 6, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 20:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 2, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 25:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 4, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 33:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 5, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 38:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 3, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 43:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 8, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      case 48:
        return (
          <React.Fragment key={index}>
            {this.renderContentTiles(props, index, 7, gridVars)}
            <ChildTile
              key={index*100}
              classList={""}
              childDetail={false}
              id={index}
              {...this.props.children[item]}
              changeView={this.props.changeView}
              sponsorshipTileCtaText="Learn More"
              gridVars={gridVars}
              handleHistory={this.props.handleHistory}
              descriptorsReceived={this.props.descriptorsReceived}
              descriptorIndex={this.props.descriptorIndexArray[index]}
              gridVarsReceived={this.props.gridVarsReceived}
              urlLink=""
            />
          </React.Fragment>
        );
      default:
        return (
          <ChildTile
            key={index}
            classList={""}
            childDetail={false}
            id={index}
            {...this.props.children[item]}
            changeView={this.props.changeView}
            sponsorshipTileCtaText="Learn More"
            gridVars={gridVars}
            handleHistory={this.props.handleHistory}
            descriptorsReceived={this.props.descriptorsReceived}
            descriptorIndex={this.props.descriptorIndexArray[index]}
            gridVarsReceived={this.props.gridVarsReceived}
            urlLink=""
          />
        );
    }
  }

  renderGrid(props, method, itemCount, gridVars) {
    if (method === "random") {
      const childItems = props.storedChildIds.randomSearch;
      if (childItems) {
        return childItems.slice(0, itemCount).map((item, index) => {
          // const isOrphan = this.classList("orphan tall-child-tile", this.props.children[item].orphanFlag, true);
          return this.tileChooser(this.props, index, item, gridVars, itemCount);
        });
      }
    } else if (method === "search") {
      const searchQuery = JSON.stringify(this.props.searchRequest.children.request.searchCriteriaList[0]);
      const childItems = this.props.storedChildIds[searchQuery];
      if (childItems) {
        return childItems.slice(0, itemCount).map((item, index) => {
          // const isOrphan = this.classList("orphan tall-child-tile", this.props.children[item].orphanFlag, true);
          return this.tileChooser(this.props, index, item, gridVars, itemCount);
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.searchMethod === "search" && this.props.lastSearchKeyUpdated !== true) {
      this.props.updatelastSearchKeyStatus(true, () => {
        this.props.lastSearchKey(this.props.submissions.children.request.searchCriteriaList[0], () => {
          let curratedValue = null;
          if (this.props.tabSelected === "curated") {
            this.props.lastSearchKeyObj.curatedSearch = this.props.curatedSearchSelected;
            //console.log("curated Search: ", this.props.lastSearchKeyObj);
          }
          triggerSponsorshipAnalyticsEvent("search.sponsorship", {
            searchParams: JSON.stringify(this.props.lastSearchKeyObj),
          });
        });
      });
    }

    if (this.state.renderGrid === true && this.props.status === "COMPLETE" && !this.props.gridVarsReceived) {
      this.props.calculateGrid(this.childrenGrid);
      this.props.animateGrid(false);
    }
  }
  handleDeepLinkError(props) {
    if (this.props.showDeepLinkError) {
      // console.log(...props);
      return (
        <div className="container">
          <Messaging {...props} />
        </div>
      );
    }
  }
  handleADPSearch() {
    if (this.props.submissions.children.request.searchCriteriaList[0].projectIdentifiers.length > 0) {
    }
  }

  render() {
    if (this.props.status == "COMPLETE") {
      return (
        <React.Fragment>
          {this.handleDeepLinkError(this.props.message)}
          <div className="grid-container">
            <section className={this.props.loading_class}>
              <div className="wvus-grid children-grid" ref={(el) => (this.childrenGrid = el)}>
                {this.renderHeader(this.props)}
                {this.renderGrid(this.props, this.props.searchMethod, this.props.itemsToShow, this.props.gridVars)}
              </div>
            </section>
            <LoadMore
              title="show more children"
              showMore={this.props.showMore}
              showLoadMore={this.props.showLoadMore}
              resetGridCalc={this.props.resetGridCalc}
            />
          </div>
        </React.Fragment>
      );
    } else if (this.props.status == "ERROR") {
      return (
        <div className="container">
          <p>
            {getErrorMessage()}
          </p>
        </div>
      );
    } else {
      return (
        <div className="spinner--wv-star">
          <div className="double-bounce1" />
          <div className="double-bounce2" />
        </div>
      );
    }
  }
}
// Get apps state and pass it as props to UserList
//      > whenever state changes, the UserList will automatically re-render
function mapStateToProps(state) {
  // console.log("map state to props", state);
  return {
    ...state,
    searchRequest: state.submissions,
  };
}

// Get actions and pass them as props to to UserList
//      > now UserList has this.props.selectUser
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getChildren: getChildren,
      searchMethodUpdater: searchMethodUpdater,
      // getChildById: getChildById,
      // getChildStoryById: getChildStoryById,
      statusUpdater: statusUpdater,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(GridView);
